/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import Button from '../common/Button';
import {Modal} from 'react-overlays';
import "../../styles/modals/removeEstablishmentModal.css";

const backdropStyle = {
  position: 'fixed',
  top: 0, bottom: 0, left: 0, right: 0,
  zIndex: 'auto',
  backgroundColor: '#000',
  opacity: 0.5
};

const tableCellStyle = {
  width: '25%',
  textAlign: 'center',
  border: '1px solid #ddd',
  padding: '2px'
};

const EstablishmentBulkRemovalForm = ({
  establishments,
  hideRemovePage,
  showModal,
  onAgreement,
  onRemove,
  removalAgreement,
}) => {
  const rows = [];
  for (let i=0; i < establishments.length; i += 4) {
    rows.push(establishments.slice(i, i+4));
  }
  return (
    <div className="remove-establishment-container">
      <Modal
        className="establishment-modal"
        backdropStyle={backdropStyle}
        show={showModal}
        onHide={hideRemovePage}
      >
        <div className="establishment-modal-dialog"
             id="remove-establishment-modal">

          <h4 id="remove-establishment-title">Confirm Removal of {establishments.length} {establishments.length < 2 ? "Establishment" : "Establishments"}</h4>
          <h5><b>NOTE: If you have already submitted the establishment data to OSHA, removing the establishment profile will not undo the submission. Removing an establishment will remove it from the Data Submission Status, the Establishment List, and from the Submission Report.</b></h5>
          <h5 className="removal-message">You can reactivate a removed establishment from the establishment’s profile page.</h5>
          <table className="bulk-removal-table">
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((establishment, colIndex) => (
                    <td className="bulk-removal-cell" key={colIndex} style={tableCellStyle}>{establishment.establishment_name}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="removal-checkbox-container">
            <input type="checkbox"
            onClick={onAgreement}
            />
            <h6>BY CHECKING THIS BOX, YOU ACKNOWLEDGE THAT YOU ARE REMOVING THESE ESTABLISHMENT PROFILES.</h6>
          </div>
          <form id="remove-establishment-container">
            <div className="remove-buttons-container">
              <a
                onClick={hideRemovePage}>
                Cancel
              </a>
              <Button
                value={establishments.length < 2 ? "Remove Establishment" : "Remove Establishments"}
                disabled={!removalAgreement || establishments.length < 1}
                onClick={onRemove}
                className="remove-establishment-btn btn btn-primary"
              />
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};
EstablishmentBulkRemovalForm.propTypes = {
  establishments: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  hideRemovePage: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  removalAgreement: PropTypes.bool.isRequired,
  onAgreement: PropTypes.func
};
export default EstablishmentBulkRemovalForm;




/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentBulkRemovalForm.js
 **/